module.exports = __webpack_public_path__ + "static/img/Knight of Wands.b286b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Knight of Wands.jpg
// module id = 1282
// module chunks = 0